// extracted by mini-css-extract-plugin
export default {"virtuoso_wrapper":"chat-task-list_virtuoso_wrapper__1dOvB"};